/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */
import * as React from "react";
import { Link } from "react-router-dom";
import cx from "classnames";
import * as Paths from "@tunnel-enums/index";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import IconSvgBreadCrumb from "@tunnel-components/@sharded/@widgets/svg/component";
import * as i18next from "i18next"; // traduction
// import { withRouter } from 'react-router-dom';
// import mp3File from ".../../../src/apps/tunnel/assets/audio/when.mp3"

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const {
    incidentnotifications,
    tmdnumbersincident,
    onslidemenu,
    onmenu,
    menu,
    supermenu,
    onsupermenu,
    tmdmenu,
    ontmdmenu,
    adminmenu,
    onadminmenu,
  } = props;

  /**
   * @description : recupère les rôles et les droits de l'utilisateur
   * @const
   * @type { objet }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-router-dom
   * @infos "https://reactjs.org"
   */
  return (
    <nav className="menu-left">
      <div className="menu-tabs" id="menu-burger" onClick={onslidemenu}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.88889 28H15.1111C16.1538 28 17 27.104 17 26V26C17 24.896 16.1538 24 15.1111 24H1.88889C0.846222 24 0 24.896 0 26V26C0 27.104 0.846222 28 1.88889 28Z"
            fill="#007ADF"
          />
          <path
            d="M2 19H30C31.104 19 32 18.104 32 17V17C32 15.896 31.104 15 30 15H2C0.896 15 0 15.896 0 17V17C0 18.104 0.896 19 2 19Z"
            fill="#007ADF"
          />
          <path
            d="M2 9H30C31.104 9 32 8.104 32 7V7C32 5.896 31.104 5 30 5H2C0.896 5 0 5.896 0 7V7C0 8.104 0.896 9 2 9Z"
            fill="#007ADF"
          />
        </svg>
      </div>

      <div className="over-menu">
        <section className="navigationMenu">
          <div
            className={cx("menuText", { "active-menu": menu[0] })}
            onClick={onmenu(0)}
          >
            {Utils.simpleAuthorizationIsAllowed(User, [
              Enums.AuthorizationRightsEnums.HOMEVIEWINCIDENTS,
            ]) && (
              <Link
                to={Paths.PathsNamesEnums.TUNNELWATCH}
                style={{ width: "100%", height: "100%" }}
              >
                <div className="separator" />
                <div className="icons-menu left ">
                  {" "}
                  <i className="icon-svg ">
                    <IconSvgBreadCrumb
                      width="20"
                      height="20"
                      incidents={true}
                    />
                  </i>
                </div>
                <p className="text-menu left">
                  {i18next.t("incidents")}
                  <span
                    className="menuNotfication"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    {incidentnotifications}
                  </span>
                </p>
              </Link>
            )}
          </div>
          <div
            className={cx("menuText", { "active-menu": menu[1] })}
            onClick={onmenu(1)}
          >
            {Utils.simpleAuthorizationIsAllowed(User, [
              Enums.AuthorizationRightsEnums.EXPLORERVIEWLISTS,
            ]) && (
              <Link
                to={Paths.PathsNamesEnums.EXPLORE}
                style={{ width: "100%", height: "100%" }}
              >
                <div className="separator" />
                <div className="icons-menu left ">
                  {" "}
                  <i className="icon-svg ">
                    <IconSvgBreadCrumb width="20" height="20" explorer={true} />
                  </i>
                </div>
                <p className="text-menu left">{i18next.t("explorer")}</p>
              </Link>
            )}
          </div>
          <div
            className={cx("menuText ", { "active-menu": menu[2] })}
            onClick={onmenu(2)}
          >
            <Link
              to={
                Utils.simpleAuthorizationIsAllowed(User, [
                  Enums.AuthorizationRightsEnums.SYSTEMVIEWTUBES,
                ])
                  ? Paths.PathsNamesEnums.SYSTEMSHOME
                  : Utils.simpleAuthorizationIsAllowed(User, [
                      Enums.AuthorizationRightsEnums
                        .AFFICHAGEINCIDENTSPARAMUPDATE,
                    ])
                  ? Paths.PathsNamesEnums.DISPLAY
                  : Utils.simpleAuthorizationIsAllowed(User, [
                      Enums.AuthorizationRightsEnums.INCIDENTSETTINGSVIEW,
                    ])
                  ? Paths.PathsNamesEnums.INCIDENTS
                  : Utils.simpleAuthorizationIsAllowed(User, [
                      Enums.AuthorizationRightsEnums.CAMERALISTS,
                    ])
                  ? Paths.PathsNamesEnums.CAMERAHOME
                  : Utils.simpleAuthorizationIsAllowed(User, [
                      Enums.AuthorizationRightsEnums.INHIBITIONVIEWLISTS,
                    ])
                  ? Paths.PathsNamesEnums.INHIBITIONS
                  : Utils.simpleAuthorizationIsAllowed(User, [
                      Enums.AuthorizationRightsEnums.SIMULATORCREATED,
                    ])
                  ? Paths.PathsNamesEnums.SIMULATOR
                  : Paths.PathsNamesEnums.INCIDENTS
              }
              style={{ width: "100%", height: "100%" }}
            >
              <div className="separator" />
              <div className="icons-menu left ">
                {" "}
                <i className="icon-svg ">
                  <IconSvgBreadCrumb
                    width="20"
                    height="20"
                    supervision={true}
                  />
                </i>
              </div>
              <p className="text-menu after left">{i18next.t("supervision")}</p>
            </Link>
          </div>
          <Styled.SubmenuText isVisible={menu[2]} className="submenuText">
            <p
              className={cx("sub-menuSupervisor text-menu ", {
                "submenu-active": supermenu[0],
              })}
              onClick={onsupermenu(0)}
            >
              {Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.SYSTEMVIEWTUBES,
              ]) && (
                <Link to={Paths.PathsNamesEnums.SYSTEMSHOME}>
                  {" "}
                  {i18next.t("systeme")}
                </Link>
              )}
            </p>
            <p
              className={cx("sub-menuSupervisor text-menu ", {
                "submenu-active": supermenu[1],
              })}
              onClick={onsupermenu(1)}
            >
              {Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.AFFICHAGEINCIDENTSPARAMUPDATE,
              ]) && (
                <Link to={Paths.PathsNamesEnums.DISPLAY}>
                  {i18next.t("affichage")}
                </Link>
              )}
            </p>
            <p
              className={cx("sub-menuSupervisor text-menu ", {
                "submenu-active": supermenu[2],
              })}
              onClick={onsupermenu(2)}
            >
              {" "}
              {Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.INCIDENTSETTINGSVIEW,
              ]) && (
                <Link to={Paths.PathsNamesEnums.INCIDENTS}>
                  {i18next.t("incidents")}
                </Link>
              )}
            </p>
            <p
              className={cx("sub-menuSupervisor text-menu ", {
                "submenu-active": supermenu[3],
              })}
              onClick={onsupermenu(3)}
            >
              {Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.CAMERALISTS,
              ]) && (
                <Link to={Paths.PathsNamesEnums.CAMERAHOME}>
                  {i18next.t("cameras")}
                </Link>
              )}
            </p>
            <p
              className={cx("sub-menuSupervisor text-menu ", {
                "submenu-active": supermenu[4],
              })}
              onClick={onsupermenu(4)}
            >
              {Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.INHIBITIONVIEWLISTS,
              ]) && (
                <Link to={Paths.PathsNamesEnums.INHIBITIONS}>
                  {i18next.t("inhibitions")}
                </Link>
              )}
            </p>
            <p
              className={cx("sub-menuSupervisor text-menu ", {
                "submenu-active": supermenu[5],
              })}
              onClick={onsupermenu(5)}
            >
              {" "}
              {Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.SIMULATORCREATED,
              ]) && (
                <Link to={Paths.PathsNamesEnums.SIMULATOR}>
                  {i18next.t("simulation")}
                </Link>
              )}
            </p>
          </Styled.SubmenuText>

          {Utils.simpleAuthorizationIsAllowed(User, [
            Enums.AuthorizationRightsEnums.TMDLAPIVIEWLIST,
          ]) && (
            <div
              className={cx("menuText", { "active-menu": menu[3] })}
              onClick={onmenu(3)}
            >
              <Link
                to={Paths.PathsNamesEnums.TMDLAPIINCIDENTS}
                style={{ width: "100%", height: "100%" }}
              >
                <div className="separator" />
                <div className="icons-menu left ">
                  <i className="icon-svg ">
                    <IconSvgBreadCrumb
                      width="20"
                      height="20"
                      lapiincons={true}
                    />
                  </i>
                </div>
                <p className="text-menu after left">
                  {i18next.t("lapi")}
                  <span
                    className="menuNotfication"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    {tmdnumbersincident}
                  </span>
                </p>
              </Link>
            </div>
          )}
          <Styled.SubmenuText isVisible={menu[3]} className="submenuText">
            <p
              className={cx("sub-menumenuTMD  text-menu ", {
                "submenu-active": tmdmenu[0],
              })}
              onClick={ontmdmenu(0)}
            >
              <Link to={Paths.PathsNamesEnums.TMDLAPIINCIDENTS}>
                {i18next.t("incidents tmd")}
              </Link>
            </p>
            <p
              className={cx("sub-menumenuTMD text-menu ", {
                "submenu-active": tmdmenu[1],
              })}
              onClick={ontmdmenu(1)}
            >
              <Link to={Paths.PathsNamesEnums.TMDLAPIEXPLORER}>
                {i18next.t("explorer")}
              </Link>
            </p>
            <p
              className={cx("sub-menumenuTMD text-menu ", {
                "submenu-active": tmdmenu[2],
              })}
              onClick={ontmdmenu(2)}
            >
              <Link to={Paths.PathsNamesEnums.TMDLAPICAMERAS}>
                {i18next.t("cameras")}
              </Link>
            </p>
          </Styled.SubmenuText>
          {Utils.simpleAuthorizationIsAllowed(User, [
            Enums.AuthorizationRightsEnums.ADMINISTRATIONHOME,
          ]) && (
            <div
              className={cx("menuText", { "active-menu": menu[4] })}
              onClick={onmenu(4)}
            >
              <Link
                to={Paths.PathsNamesEnums.VERSIONNING}
                style={{ width: "100%", height: "100%" }}
              >
                <div className="separator" />
                <div className="icons-menu left ">
                  <i className="icon-svg ">
                    <IconSvgBreadCrumb
                      width="20"
                      height="20"
                      administration={true}
                    />
                  </i>
                </div>
                <p className="text-menu after left">
                  {i18next.t("administration")}
                </p>
              </Link>
            </div>
          )}

          {Utils.simpleAuthorizationIsAllowed(User, [
            Enums.AuthorizationRightsEnums.ADMINISTRATIONUSERVERSION,
          ]) && (
            <Styled.SubmenuText isVisible={menu[4]} className="submenuText">
              <p
                className={cx("sub-menuAdministrator  text-menu ", {
                  "submenu-active": adminmenu[0],
                })}
                onClick={onadminmenu(0)}
              >
                <Link to={Paths.PathsNamesEnums.VERSIONNING}>
                  {i18next.t("versions")}
                </Link>
              </p>
              <p
                className={cx("sub-menuAdministrator text-menu ", {
                  "submenu-active": adminmenu[1],
                })}
                onClick={onadminmenu(1)}
              >
                {Utils.simpleAuthorizationIsAllowed(User, [
                  Enums.AuthorizationRightsEnums.ADMINISTRATIONUSERSLISTS,
                ]) && (
                  <Link to={Paths.PathsNamesEnums.USERS}>
                    {i18next.t("utilisateurs")}
                  </Link>
                )}
              </p>
              {false && (
                <p
                  className={cx("sub-menuAdministrator text-menu ", {
                    "submenu-active": adminmenu[2],
                  })}
                  onClick={onadminmenu(2)}
                >
                  <Link to={Paths.PathsNamesEnums.STATISTICS}>
                    {i18next.t("statistiques")}
                  </Link>
                </p>
              )}
            </Styled.SubmenuText>
          )}
        </section>
      </div>
    </nav>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  incidentnotifications?: any;
  tmdnumbersincident?: any;
  onslidemenu?: any;
  onmenu?: any;
  menu?: any;
  supermenu?: any;
  onsupermenu?: any;
  tmdmenu?: any;
  ontmdmenu?: any;
  adminmenu?: any;
  onadminmenu?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/menu/component.tsx